import React from 'react';
import styled from 'styled-components';
import { Tab, Tabs } from '@mui/material';

const StyledTabs = styled(Tabs)`
  background-color: var(--background-chart);
  & .MuiTabs-indicator {
    background-color: var(--background-chart-tabs);
  }
`;

const StyledTab = styled(Tab)`
  min-width: 100px;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 0.8rem;
  margin-left: 12px;
`;

interface MapTabsProps {
  value: string;
  onChange: (event: React.ChangeEvent<unknown>, value: string) => void;
  options: Array<{ value: string; label: string }>;
}

const MapTabs = ({ value, onChange, options }: MapTabsProps) => (
  <StyledTabs value={value} onChange={onChange}>
    {options.map(({ value, label }) => (
      <StyledTab key={value} value={value} label={label} />
    ))}
  </StyledTabs>
);

export default MapTabs;
